// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"94":"Login","380":"WindHome","684":"Admin","779":"SolarHome"}[chunkId] + "." + {"94":"1e1bb5c8","380":"fb893ab9","684":"24d0f8ce","779":"dc5dfd99"}[chunkId] + ".css";
};